module.exports = __webpack_public_path__ + "img/ИФ-1(А)-040-m.f78d36b0.png";